import React from 'react'
import {Icon} from '@chakra-ui/react'

const GridIconA = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <rect x="1" y="8" width="15" height="24.32" fill="currentColor" />
            <rect
                x="20.4004"
                y="14.42"
                width="6.72"
                height="11.49"
                stroke="currentColor"
                strokeWidth="2"
            />
            <rect
                x="31.2803"
                y="14.42"
                width="6.72"
                height="11.49"
                stroke="currentColor"
                strokeWidth="2"
            />
        </Icon>
    )
}

export default GridIconA
